var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import AumData from "./AumData";
import di from "../../di/serviceLocator";
import { useSelector } from "react-redux";
import Loader from "../../../../../../shared-library/components/Loader";
var AumAccordianTable = function () {
    var _a = __read(React.useState(false), 2), isSidebarOpen = _a[0], setSidebarOpen = _a[1];
    var _b = __read(React.useState(), 2), aumData = _b[0], setAumData = _b[1];
    var aumRedux = useSelector(function (state) { return state.Clients.AUMData.reducersData.data; });
    var aumLoader = useSelector(function (state) { return state.Clients.AUMData.commonData; }).loader;
    var selectedAcount = useSelector(function (state) { return state.Clients.ClientSearch.reducersData.selected; });
    var _c = __read(React.useState(""), 2), subDataHead = _c[0], setSubDataHead = _c[1];
    // async function getAumSub() {
    //   if (selectedAcount?.accountCode && subDataHead)
    //     setAumSubData(
    //       await di.clients.getAUMSummaryDetails({
    //         AcCode: selectedAcount.accountCode,
    //         Flag: subDataHead,
    //       })
    //     );
    // }
    React.useEffect(function () {
        if (selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode)
            di.clients.getRevenueAUMData({ acCode: selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode });
    }, [selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode]);
    React.useEffect(function () {
        setAumData(aumRedux);
    }, [aumRedux]);
    // React.useEffect(() => {
    //   if (subDataHead && selectedAcount.accountCode) getAumSub();
    // }, [subDataHead, selectedAcount]);
    return (React.createElement(React.Fragment, null, aumLoader ? (React.createElement("div", { className: "position-relative client-loader" },
        React.createElement(Loader, null))) : (React.createElement("div", { className: "profile-accordion-table-block Aum-data-section table-responsive commonscroll-new" },
        React.createElement("label", { className: "DMSanBold_18_700 txt_blackOne1 py-2" }, "AUM"),
        React.createElement("table", { className: "profile-main-table Aumdata-table" },
            React.createElement("thead", null,
                React.createElement("tr", { className: "profile-main-headings" },
                    React.createElement("th", { className: "DMSansMedium_12_500 txt_primaryGrey" }, "Asset Class"),
                    React.createElement("th", { className: "DMSansMedium_12_500 txt_primaryGrey text-right" }, "Invested Value (\u20B9)"),
                    React.createElement("th", { className: "DMSansMedium_12_500 txt_primaryGrey text-right" }, "Market Value (\u20B9)"),
                    React.createElement("th", { className: "DMSansMedium_12_500 txt_primaryGrey text-right" }, "Return (%)"),
                    React.createElement("th", { className: "DMSansMedium_12_500 txt_primaryGrey text-right" }, "% of Total Holdings"))),
            React.createElement(AumData, { accountCode: selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode, data: aumData === null || aumData === void 0 ? void 0 : aumData.data, setSubDataHead: setSubDataHead, mainAumData: aumData }))))));
};
export default AumAccordianTable;
